import { useState, useRef } from "react"
import ReactDOM from "react-dom";
import Admin from "./admin";
import UserUpdate from "../datawriter/userUpdate";
import CatSel from "./selectQueries/catSel"
import OrgSel from "./selectQueries/orgSel";
import SecSel from "./selectQueries/secSel";
import StateSel from "./selectQueries/stateSel"
import { useEffect } from "react";
import { useTableManager } from "../hooks/useTableManager";

const NOTE_SEARCH_KEYS = ['note', 'addedBy.userId', 'addedBy'];

export default function AdminForm({temp, old, em, token}){
    let blockS = false;
    let blockH = false;
    const defined = (v) => v !== undefined && v !== null && v !== "";
    const today = new Date();

    if(defined(old)){
    if(!(old.userDetails.roles.includes("fcwdHelpDesk")) && (old.userDetails.roles.includes("fcwdState"))){
            if(old.userDetails.roles.includes("fcwdHelpDesk")){
                blockS = true;
            }
            if(old.userDetails.roles.includes("fcwdState")){
                blockH = true;
            }
        }
    }

    console.log("Temp: "+JSON.stringify(temp) + "email: "+em);

    const insertRef = useRef(null);
    const logRef = useRef(null);
    const topRef = useRef(null);
    const [msg, setMsg] = useState([]);
    const [successMsg, setSuccessMsg] = useState("");
    const [blockState, setBlockState] = useState(blockS);
    const [blockHelp, setBlockHelp] = useState(blockH);
    const [showModal, setShowModal] = useState(false);
    const [activeTab, setActiveTab] = useState('details');
    const [notes, setNotes] = useState([]);
    const {
        currentPage: notesCurrentPage, 
        handleNextPage: handleNextNotePage, 
        handlePrevPage: handlePrevNotePage,
        itemsPerPage: notesPerPage, 
        setItemsPerPage: setNotesPerPage,
        currentData: currentNotes, 
        totalItems: totalNotes, 
        totalPages: totalNotesPages, 
        startIndex: notesStartIndex
    } = useTableManager(notes, NOTE_SEARCH_KEYS, '', '');

    useEffect(() => {
        setNotesPerPage(5);
    }, [setNotesPerPage]);

    let newEmail = true;    
    const defaults = {
        "userId"            : temp.userId,
        "firstName"         : "",
        "middleName"        : "",
        "lastName"          : "",
        "userEmail"         : temp.userEmail,
        "siBadgeNum"        : "",
        "orgination"        : "",
        "jobCategoryId"     : "Select",
        "organization"      : "",
        "officeTypeId"      : "Select",
        "securityQuestion"  : "Select",
        "securityAnswer"    : "",
        "orgCoordinator"    : "",
        "orgCoordEmail"     : "",
        "isActive"          : false,
        "hascdlisAdmin"     : false,
        "hascdlisUser"      : "checked",
        "hasMinimalDrivReq" : false,
        "hasFcwd"           : false,
        "hasFcwdTechSupp"   : false,
        "hasTechSupp"       : false,
        "hasMxSearch"       : false,
        "hasCnSearch"       : false,
        "hasCnFcwd"         : false,
        "hasCdlisFcwdOnly"  : false,
        "hasBatch"          : false,
        "hasHelpDesk"       : false,
        "lastAccessed"      : "",
        "state"             : "AK",
        "notes"             : 'User Created',
        "adminEmail"        : em
    }

console.log(JSON.stringify(old))

    let inUse = defaults;
    if(temp !== undefined){
        inUse = temp;
        if(temp.userEmail === undefined){
            newEmail = false;
        }
    } else {
        inUse = defaults;
    }
    

    const [formData, setFormData] = useState(inUse);

    if((formData.isActive === false) || (formData.isActive === "false")){
        formData.isActive = false;
    }

    const clearMessages = () => {
        setMsg([]);
        setSuccessMsg("");
    };

    useEffect(() => {
        if (!temp || !temp.userId) {
            setNotes([]);
            return; 
        }
            const fetchData = async () => {
                try {
                    const response = await fetch(`/api/user/notes/${temp.userId}`, {
                        method: "GET", 
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        }
                    });

                    // Manually catch 404s, 500s, etc.
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    // Await the json parsing
                    const data = await response.json();
                    console.log("Full response payload:", data);

                    const notesArray = data.items;
                    // Sort the notes array
                        const sortedNotes = notesArray.sort((a, b) => {
                        const dateA = new Date(a.date).getTime();
                        const dateB = new Date(b.date).getTime();

                        const isInvalidA = isNaN(dateA);
                        const isInvalidB = isNaN(dateB);

                        // If both are invalid, keep their original order
                        if (isInvalidA && isInvalidB) return 0;
                        
                        // If only A is invalid, push A to the bottom
                        if (isInvalidA) return 1;
                        
                        // If only B is invalid, push B to the bottom
                        if (isInvalidB) return -1;

                        // If both are valid, sort descending (most recent first)
                        return dateB - dateA;
                    });

                console.log("My sorted notes:", sortedNotes);
                setNotes(sortedNotes);
                } catch (error) {
                    console.error('caught error: ', error);
                }
              
            };
            fetchData();
        }, []);
    
    const handleBack = () => {
        return(
            <Admin />
        )
    }

    const formatDate = (d) => {

        if(d === "No data"){
            return d;
        }
        
        return new Date(d).toLocaleDateString();
        
    }

    const countDays = (date1 ,date2) => {
        const d1 = new Date(date1);
        const d2 = new Date(date2);
        const ONE_DAY = 1000 * 60 * 60 * 24;
        const startUTC = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
        const endUTC =   Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());
        const differenceMs = startUTC - endUTC;
        return Math.floor(parseInt(differenceMs / ONE_DAY)); 
        //return 5
    }


    let last ="";
    let days = "" 

    if((temp.lastAccessed !== undefined) || (temp.lastAccessed !== null)){
        try {
            if(temp.lastAccessed.length < 15){
                //last = new Date().toISOString();
                days = "No data"
            } else {
                last = JSON.parse(temp.lastAccessed);
                days = countDays(today, last);
            }
        }catch(e) {
            days = "No Data"
        }
    } 


    function validateEmail(email) {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    }

    const handleError = (errorText) => {
        // Unmount the component so it stops rendering
        ReactDOM.unmountComponentAtNode(insertRef.current);
        
        // Set the error message and scroll to the top!
        setMsg([<li>{errorText}</li>]);
        topRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const handleSuccess = (method) => {
        ReactDOM.unmountComponentAtNode(insertRef.current);

        if (method === "POST") {
            setSuccessMsg("New user successfully created!");
            //setFormData(defaults);
        } else {
            setSuccessMsg("User successfully updated!");
        }
        setMsg([]); 
        topRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const handleSubmit = (e, formData) => {
        setShowModal(false);
        e.preventDefault();
        let msgList = [];
        let hasRole = false;

        //setFormData((formData) => ({ ...formData, adminEmail: em}))
        if((formData.hasBatch ===  "checked") || (formData.hasBatch === true)){hasRole = true}
        if((formData.hasCnFcwd === "checked") || (formData.hasCnFcwd === true)){hasRole = true}
        if((formData.hasCnSearch === "checked") || (formData.hasCnSearch === true)){hasRole = true}
        if((formData.hasFcwd === "checked") || (formData.hasFcwd === true)){hasRole = true}
        if((formData.hasFcwdTechSupp === "checked") || (formData.hasFcwdTechSupp === true)){hasRole = true}
        if((formData.hasHelpDesk === "checked") || (formData.hasHelpDesk === true)){hasRole = true}
        if((formData.hasMinimalDrivReq === "checked") || (formData.hasMinimalDrivReq === true)){hasRole = true}
        if((formData.hasMxSearch === "checked") || (formData.hasMxSearch === true)){hasRole = true}
        if((formData.hasTechSupp === "checked") || (formData.hasTechSupp ===  true)){hasRole = true}
        if((formData.hascdlisAdmin === "checked") || (formData.hascdlisAdmin === true)){hasRole = true}
        if((formData.hascdlisUser === "checked") || (formData.hascdlisUser === true)){hasRole = true}
        if((formData.hasCdlisFcwdOnly === "checked") || (formData.hasCdlisFcwdOnly === true)){hasRole = true}


        if(formData.firstName === undefined){ msgList.push(<li>First Name Requried</li>); }
        if(formData.lastName === undefined){ msgList.push(<li>Last Name Requried</li>); }
        if((formData.userEmail === undefined) ||
            !formData.userEmail.includes('@')
        ){msgList.push(<li>Invalid User Email</li>)}
        if(formData.orgCoordEmail === undefined){ msgList.push(<li>Coordinator Email Requried</li>); }

        if(formData.state ===  undefined) {
            msgList.push(<li>State Selection Required</li>)
        }

        if(hasRole === false){
            msgList.push(<li>At Least one Role Selection is required</li>)
        }

        if(formData.notes === undefined){
            msgList.push(<li>Notes Must be at Least 6 Characters long</li>)
        }

        if(!defined(formData.state)){
            msgList.push(<li>State Selection Required</li>)
        }

        if(formData.notes !== undefined) {
            if(formData.notes.length < 6){
                msgList.push(<li>Notes Must be at Least 6 Characters long</li>)
            }
        }
        if(formData.hasFcwd && formData.hasHelpDesk){
            msgList.push(<li>Please select one, FCWD State User or FCWD Help Desk User.</li>)
        }
        let emErr = false;
        if(!formData.userEmail?.includes('.')){
            emErr = true
        }

        let [e1, e2] = (formData.userEmail || "").split("@");
                if(e1 === undefined){
                    emErr = true 
                    e1 ="";
                }
                if(e2 === undefined){
                    emErr = true;
                    e2 = "";
                }
                if((e1.length < 3) || (e2.length < 3)){
                    emErr = true;
                } 
        
        if(emErr){
            msgList.push(<li>Invalid User Email</li>)
        }

        if(!formData.orgCoordEmail?.includes('.')){
            emErr = true
        }
        
        let [ce1, ce2] = (formData.orgCoordEmail || "").split("@");
                if(ce1 === undefined){
                    emErr = true 
                    ce1 ="";
                }
                if(ce2 === undefined){
                    emErr = true;
                    ce2 = "";
                }
                if((ce1.length < 3) || (ce2.length < 3)){
                    emErr = true;
                } 
        
        if(emErr){
            msgList.push(<li>Invalid Coordinator Email</li>)
        }
    
        if(msgList.length > 0){
            setMsg(msgList);
            topRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }
        
       try {    
            ReactDOM.render(
                <UserUpdate data={formData} old={old} token={token} onSuccess={handleSuccess} onError={handleError} />,
                insertRef.current
            ); 
        } catch(err){
            alert(err)
        }
    }



    const handleDeactivation = (e) =>{
        try {    
            ReactDOM.render(
                <UserUpdate data={formData} old={old} token={token} onSuccess={handleSuccess} onError={handleError} />,
                insertRef.current
            );
        } catch(err){
            alert(err)
        }
    }

    
    const handleClear = (e) =>{
        e.preventDefault();
        setFormData(defaults);
    }

    const handleChange = (event) => {
        event.preventDefault();
        clearMessages();
        const { name, value } = event.target;
        setFormData((formData) => ({ ...formData, [name]: value }));
        setFormData((formData) => ({ ...formData, adminEmail: em}))
    }

    const isUsrActive = () => {
        clearMessages();
        if(formData.isActive){
            setFormData((formData) => ({ ...formData, isActive: false }));
        } else {
            setFormData((formData) => ({ ...formData, isActive: 'checked'  })); 
            //etFormData((formData) => ({ ...formData, lastAccessed: today }));        
        }
    }

    const addUser = () => {
        if(formData.hascdlisUser){
            setFormData((formData) => ({ ...formData, hascdlisUser: false }));
        } else {
            setFormData((formData) => ({ ...formData, hascdlisUser: 'checked' }));          
        }
    }

    const addAdmin = () => {
        if(formData.hascdlisAdmin){
            setFormData((formData) => ({ ...formData, hascdlisAdmin: false }));
        } else {
            setFormData((formData) => ({ ...formData, hascdlisAdmin: 'checked' }));          
        }
    }

    const addMinimalDrivReq = () => {
        if(formData.hasMinimalDrivReq){
            setFormData((formData) => ({ ...formData, hasMinimalDrivReq: false }));
        } else {
            setFormData((formData) => ({ ...formData, hasMinimalDrivReq: 'checked' }));          
        }
    }
    const addFcwdTechSupp = () => {
        if(formData.hasFcwdTechSupp){
            setFormData((formData) => ({ ...formData, hasFcwdTechSupp : false }));
        } else {
            setFormData((formData) => ({ ...formData, hasFcwdTechSupp : 'checked' }));          
        }
    }

    const addTechSupp = () => {
        if(formData.hasTechSupp){
            setFormData((formData) => ({ ...formData, hasTechSupp: false }));
        } else {
            setFormData((formData) => ({ ...formData, hasTechSupp: 'checked' }));          
        }
    }

    const addMxSearch = () => {
        if(formData.hasMxSearch){
            setFormData((formData) => ({ ...formData, hasMxSearch: false }));
        } else {
            setFormData((formData) => ({ ...formData, hasMxSearch: 'checked' }));          
        }
    }

    const addCnSearch = () => {
        if(formData.hasCnSearch){
            setFormData((formData) => ({ ...formData, hasCnSearch: false }));
        } else {
            setFormData((formData) => ({ ...formData, hasCnSearch: 'checked' }));          
        }
    }

     const addCdlisFcwdOnly = () => {     
        if(formData.hasCdlisFcwdOnly){
            setFormData((formData) => ({ ...formData, hasCdlisFcwdOnly: false }));
        } else {
            setFormData((formData) => ({ ...formData, hasCdlisFcwdOnly: 'checked' }));          
        }
    }

    const addBatch = () => {
        if(formData.hasBatch){
            setFormData((formData) => ({ ...formData, hasBatch: false }));
        } else {
            setFormData((formData) => ({ ...formData, hasBatch: 'checked' }));          
        }
    }    

    const addFcwd = (e) => {
        if(formData.hasFcwd){
            setBlockHelp(false)
            setFormData((formData) => ({ ...formData, hasFcwd: false }));
        } else {
            setBlockHelp(!formData.hasHelpDesk)
            setFormData((formData) => ({ ...formData, hasFcwd: 'checked' }));        
        }
    }

     const addHelpDesk = (e) => {
        if(formData.hasHelpDesk){
            setBlockState(false);
            setFormData((formData) => ({ ...formData, hasHelpDesk: false }));
        } else {
            setBlockState(!formData.hasFcwd);
            setFormData((formData) => ({ ...formData, hasHelpDesk: 'checked' }));       
        }
    }

    return(
        <div>
            <div ref={topRef}></div>
            <div id='table'>
                <div id='banner-search'>
                    <h4>User Administration</h4>
                    <p>User Last Query - {formatDate(last)} - {days} day(s) ago</p>
                </div>
                {/* --- TABS NAVIGATION --- */}
                <div style={{ display: 'flex', borderBottom: '1px solid #ccc', marginBottom: '15px', marginTop: '10px' }}>
                    <button
                        type="button"
                        style={{ padding: '10px 20px', cursor: 'pointer', border: '1px solid #ccc', borderBottom: activeTab === 'details' ? '2px solid white' : '1px solid #ccc', backgroundColor: activeTab === 'details' ? '#fff' : '#f8f9fa', marginBottom: '-1px', fontWeight: activeTab === 'details' ? 'bold' : 'normal', color: activeTab === 'details' ? '#0071bc' : '#333' }}
                        onClick={() => setActiveTab('details')}
                    >
                        User Details
                    </button>
                    <button
                        type="button"
                        style={{ padding: '10px 20px', cursor: 'pointer', border: '1px solid #ccc', borderBottom: activeTab === 'notes' ? '2px solid white' : '1px solid #ccc', backgroundColor: activeTab === 'notes' ? '#fff' : '#f8f9fa', marginBottom: '-1px', marginLeft: '5px', fontWeight: activeTab === 'notes' ? 'bold' : 'normal', color: activeTab === 'notes' ? '#0071bc' : '#333' }}
                        onClick={() => setActiveTab('notes')}
                    >
                        Notes History
                    </button>
                </div>
                {activeTab === 'details' && (
                <form id="Index-form">
                    {successMsg && (
                        <div role="alert" style={{ color: 'green', fontWeight: 'bold', marginBottom: '15px' }}>
                            <p>{successMsg}</p>
                        </div>
                    )}
                    <div role="alert" style={{color:'red'}}>
                        <p>{msg}</p>
                    </div>
                    <tr>
                        <th>
                            <label for="firstName" className="form-label">First:</label>
                            <input type="text" 
                                id="required-input"
                                className="form-control is-invalid"
                                name="firstName"
                                size="15"
                                onChange={(e) => handleChange(e)}
                                value={formData.firstName}>
                            </input>
                        </th>  
                        <th>
                            <label for="middleName" className="form-label">Middle:</label>
                            <input type="text"
                                className="form-control"
                                name="middleName"
                                size="12"
                                onChange={(e) => handleChange(e)}
                                value={formData.middleName}>
                            </input>
                        </th>  
                        <th>
                            <label for="lastName" className="form-label">Last:</label>
                            <input type="text"
                                className="form-control is-invalid" 
                                name="lastName"
                                size="20"
                                onChange={(e) => handleChange(e)}
                                value={formData.lastName}
                                id="required-input">
                            </input>
                        </th> 
                    </tr>
                    <br />
                    <tr>
                        <th><p>
                            <label className="form-label">Email Address:</label>                          
                            <input type="text"
                                className="form-control is-invalid" 
                                id="required-input"
                                name="userEmail"
                                size="40"
                                readOnly={newEmail}
                                onChange={(e) => handleChange(e)}
                                placeholder={formData.userEmail}>
                            </input>
                        </p></th>
                    </tr>
                    <tr>
                        <th><p>
                            <label className="form-label">State:</label>
                            <StateSel handleChange={(e) => handleChange(e)} formData={formData} />
                        </p></th>
                            <th><p>
                             <label className="form-label">Category:</label>
	                             <CatSel handleChange={(e) => handleChange(e)} formData={formData}
                             url =  {"api/system/jobCategories" } token ={token} />
                         </p></th>
                    </tr>
                    <tr>
                        <th>
                            <label className="form-label">Organization:</label>                         
                            <input typr="text"
                                className="form-control"
                                name="organization"
                                onChange={(e) => handleChange(e)}
                                value={formData.organization}
                            ></input>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <label className="form-label">Notes:</label>                         
                            <textArea
                                className="form-control is-invalid"
                                name="notes"
                                value={formData.notes}
                                onChange={(e) => handleChange(e)}
                                rows={2} 
                                cols={30} 
                            />
                        </th>
                    </tr>                    
                    <br />
                    <div style={{ fontWeight: 'bold' }}>
                    <p>
                        <tr>
                            <th>
                                <label className="form-label">Roles:</label>
                            </th>
                        </tr>
                            <tr>
                                 <th>
                                    <input className="form-check-input" 
                                        type="checkbox" value={formData.isActive}
                                        checked={formData.isActive}
                                        style={{ border: "1px solid #000"}}
                                        onChange={isUsrActive} />
                                    <label className="form-label">
                                        &nbsp;&nbsp;Active User
                                    </label>                                   
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <input className="form-check-input" 
                                        type="checkbox" value={formData.hascdlisUser}
                                        checked={formData.hascdlisUser}
                                        style={{ border: "1px solid #000"}}
                                        onChange={addUser} />
                                    <label className="form-label">
                                        &nbsp;&nbsp;CDLIS User
                                    </label>                                   
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <input className="form-check-input"
                                        type="checkbox" value={formData.hasMinimalDrivReq} 
                                        checked={formData.hasMinimalDrivReq}
                                        style={{ border: "1px solid #000"}}
                                        onChange={addMinimalDrivReq} />
                                    <label className="form-label">
                                         &nbsp;&nbsp;Minimal Driver Request
                                    </label>                                   
                                </th>
                            </tr>
                              <tr>
                                 <th>
                                    <input className="form-check-input" 
                                        type="checkbox" value={formData.hasBatch}  
                                        style={{ border: "1px solid #000"}}
                                        checked={formData.hasBatch}
                                        onChange={addBatch} />
                                    <label className="form-label">
                                         &nbsp;&nbsp;Batch User
                                    </label>                                   
                                </th>
                            </tr>
                            {/*
                            <tr>
                                 <th>
                                    <input className="form-check-input" 
                                        type="checkbox" value={formData.hasCnSearch} 
                                        checked={formData.hasReports}
                                        style={{ border: "1px solid #000"}}
                                        onChange={addReports} />
                                    <label className="form-label">
                                         &nbsp;&nbsp;Access Reports
                                    </label>                                   
                                </th>
                            </tr>
                            */}
                             <tr>
                                <th>
                                    <input className="form-check-input" 
                                        type="checkbox" value={formData.hasFcwd} 
                                        checked={formData.hasFcwd}
                                        onChange={addFcwd} 
                                        style={{ border: "1px solid #000"}}
                                        disabled={blockState}/>
                                
                                    <label className="form-label">
                                        &nbsp;&nbsp;FCWD State User 
                                    </label>                                   
                                </th>
                            </tr>
                              <tr>
                                 <th>
                                    <input className="form-check-input" 
                                        type="checkbox" value={formData.hasHelpDesk} 
                                        checked={formData.hasHelpDesk}
                                        style={{ border: "1px solid #000"}}
                                        onChange={addHelpDesk} 
                                        disabled={blockHelp}/>
                                    <label className="form-label">
                                         &nbsp;&nbsp;FCWD Help Desk User
                                    </label>                                   
                                </th>
                            </tr>
                            <tr>
                                 <th>
                                    <input className="form-check-input" 
                                        type="checkbox" value={formData.hasMxSearch} 
                                        checked={formData.hasMxSearch}
                                        style={{ border: "1px solid #000"}}
                                        onChange={addMxSearch} />
                                    <label className="form-label">
                                         &nbsp;&nbsp;Allow Mexico Searches
                                    </label>                                   
                                </th>
                            </tr>
                            <tr>
                                 <th>
                                    <input className="form-check-input" 
                                        type="checkbox" value={formData.hasCnSearch} 
                                        checked={formData.hasCnSearch}
                                        style={{ border: "1px solid #000"}}
                                        onChange={addCnSearch} />
                                    <label className="form-label">
                                         &nbsp;&nbsp;Allow Canada Searches
                                    </label>                                   
                                </th>
                            </tr>
                            <tr>
                                 <th>
                                    <input className="form-check-input" 
                                        type="checkbox" value={formData.hasCdlisFcwdOnly} 
                                        checked={formData.hasCdlisFcwdOnly}
                                        style={{ border: "1px solid #000"}}
                                        onChange={addCdlisFcwdOnly} />
                                    <label className="form-label">
                                         &nbsp;&nbsp;CDLIS Canada FCWD Only
                                    </label>                                   
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <input className="form-check-input" 
                                        type="checkbox" value={formData.hascdlisAdmin} 
                                        checked={formData.hascdlisAdmin}
                                        style={{ border: "1px solid #000"}}
                                        onChange={addAdmin} />
                                    <label className="form-label">
                                       &nbsp;&nbsp;Administrator
                                    </label>                                   
                                </th>
                            </tr>
                        
                            <tr>
                            </tr>
                    </p>
                    </div>
                    <center>
                        <tr><th>
                        <label className="form-label">Organization:</label>
                        </th></tr>
                    </center>
                    <br />
                    <tr>
                    </tr>
                    <tr>
                        <th>
                            <label className="form-label">Office Coordinator:</label>
                        </th>
                        <th>
                            <input type="text"
                                className="form-control"
                                size="45"
                                name="orgCoordinator"
                                onChange={(e) => handleChange(e)}
                                value={formData.orgCoordinator}
                            ></input>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <label>Coordinator Email:</label>
                        </th>
                        <th>
                            <input type="text" id="required-input"
                                className="form-control is-invalid"
                                size="45"
                                name="orgCoordEmail"
                                onChange={(e) => handleChange(e)}
                                value={formData.orgCoordEmail}                                
                            ></input>
                        </th>
                    </tr>
                    <center>
                        <button id="button" style={{"textAlign": "start"}}
                        className="btn btn-primary" 
                            onClick={(e) => handleSubmit(e, formData)}>
                            Submit
                        </button>
                        <button  id="button" style={{"textAlign": "start"}}
                            className="btn btn-primary"
                            onClick={handleClear}>
                            Clear
                        </button>
                        <button
                        id="button" style={{"textAlign": "start"}}
                            onClick={handleBack}
                            className="btn btn-primary">
                            Admin Home
                        </button>
                    </center>
                </form>
                )}
                {/* --- TAB CONTENT: NOTES HISTORY --- */}
                {activeTab === 'notes' && (
                    <div id="notes-history" style={{ padding: '15px', backgroundColor: '#fff', border: '1px solid #ddd', borderTop: 'none', marginTop: '-15px' }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                            <h5 style={{ margin: 0, color: '#333' }}>Permission Change Notes</h5>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <span style={{ marginRight: "8px", fontSize: "14px" }}>Show entries:</span>
                                <select 
                                    className="form-select form-select-sm" 
                                    style={{ width: "80px" }}
                                    value={notesPerPage}
                                    onChange={(e) => setNotesPerPage(Number(e.target.value))}
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                </select>
                            </div>
                        </div>

                        <table className="table table-striped table-bordered mb-2" style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
                            <thead className="thead-light" style={{ backgroundColor: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ padding: '12px', borderBottom: '2px solid #ddd', borderTop: '1px solid #ddd' }}>Date & Time</th>
                                    <th style={{ padding: '12px', borderBottom: '2px solid #ddd', borderTop: '1px solid #ddd' }}>Changed By (UserID)</th>
                                    <th style={{ padding: '12px', borderBottom: '2px solid #ddd', borderTop: '1px solid #ddd' }}>Note / Comment</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentNotes.map((note, index) => (
                                    <tr key={note.id || index}>
                                        <td style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>{new Date(note.date).toLocaleString()}</td>
                                        <td style={{ padding: '12px', borderBottom: '1px solid #ddd', color: '#0071bc', fontWeight: '500' }}>{note?.addedBy?.userId || note.addedBy}</td>
                                        <td style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>{note.note}</td>
                                    </tr>
                                ))}
                                {notes.length === 0 && (
                                    <tr>
                                        <td colSpan="3" style={{ padding: '20px', textAlign: 'center', fontStyle: 'italic', color: '#6c757d' }}>
                                            No notes have been entered for this user yet.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* Pagination Footer using the hook variables */}
                        <div style={{
                            display: "flex", 
                            justifyContent: "space-between", 
                            alignItems: "center", 
                            padding: "10px 5px",
                            width: "100%"
                        }}>
                            <div className="text-muted" style={{ fontSize: "14px" }}>
                                Showing <b>{totalNotes === 0 ? 0 : notesStartIndex + 1}</b> to <b>{Math.min(notesStartIndex + notesPerPage, totalNotes)}</b> of <b>{totalNotes}</b> entries
                            </div>
                            
                            {totalNotesPages > 1 && (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <button 
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary" 
                                        disabled={notesCurrentPage === 1}
                                        onClick={handlePrevNotePage}
                                        style={{ marginRight: "10px" }}
                                    >
                                        Previous
                                    </button>
                                    
                                    <span style={{ fontSize: "14px" }}>
                                        Page <b>{notesCurrentPage}</b> of {totalNotesPages}
                                    </span>
                                    
                                    <button 
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary" 
                                        disabled={notesCurrentPage === totalNotesPages}
                                        onClick={handleNextNotePage}
                                        style={{ marginLeft: "10px" }}
                                    >
                                        Next
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            {/* Bootstrap Modal */}
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Confirm Deactivation</h5>
                        <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowModal(false)}
                        />
                    </div>
                    <div className="modal-body">
                        <p>
                        Are you sure you want to deactivate this user?
                        </p>
                    </div>
                    <div className="modal-footer">
                        <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowModal(false)}
                        >
                        Cancel
                        </button>
                        <button
                        type="button"
                        className="btn btn-danger"
                        onClick={handleDeactivation}
                        >
                        Deactivate
                        </button>
                    </div>
                    </div>
                </div>
                </div>
            )}
            <div ref={logRef}>
            </div>
            <div ref={insertRef}>
            </div>
        </div>
    )
}